<div>
    <div class="row center-item">
        <div class="col-md-12">
            <app-tooltip *ngIf="mobileQuery.matches || fullScreen == false" class="tooltip-container"
                [Mensaje]="bufferButtonMsg" [isVisible]="isBufferButtonMsgVisible"
                (visibilityChange)="onVisibilityChange($event)"></app-tooltip>
            <button class="btnPin"
                mat-raised-button (click)="onSetBufferCenter()">
                <p class="color-white center-item"><mat-icon class="example-tab-icon">control_point</mat-icon> Definir
                    Punto Activo</p>
            </button>
        </div>
    </div>
    <div class="row center-item">
        <div class="text-center" [hidden]="!isVisibleControlSliderRadio">
            <h3>Radio Km</h3>
        </div>
        <mat-slider 
        [hidden]="!isVisibleControlSliderRadio" 
        thumbLabel name="radioSelector" 
        [displayWith]="formatLabel"
        step="0.2" 
        [min]="initialRadio" 
        max="5" 
        aria-label="kilometros" 
        showTickMarks discrete class="cdk-focused"
        (change)="onChangeRadio(inputSlider)">
            <input matSliderThumb [(ngModel)]="mapHelperService.bufferRadioKm" #inputSlider>
        </mat-slider>
    </div>
</div>